import React, { Component } from 'react';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { API_ROOT } from '../../../../../../../api/Routes';
import PreviewImageModal from 'PreviewImageModal';

const InnerContainer = styled.div`
  position: relative;
`;

const Image = styled.img`
  // max-height: 18rem;
  // width: 100%;
  // margin-bottom: 0;
  max-height: 100%;
  max-width: 100%;
`;

const FieldImageName = styled.div`
  margin-top: 10px;
  font-size: 0.75rem;
  color: grey;
  font-weight: 300;
`;

class AddPhoto extends Component {
  state = {
    preview: false,
    activeAsset: null,
  };

  openPreview = asset => {
    this.setState({
      preview: true,
      activeAsset: asset,
    });
  };

  closePreview = () => {
    this.setState({
      preview: false,
      activeAsset: null,
    });
  };

  render() {
    const { photo, photo1, photo2 } = this.props;

    return (
      <Grid container spacing={16}>
        <Grid item xs={12} md={6}>
          <InnerContainer>
            <Image
              onClick={() => this.openPreview(photo)}
              src={`${API_ROOT}/asset/${photo}`}
            />
          </InnerContainer>
          <FieldImageName>Luminaire image</FieldImageName>
        </Grid>
        <Grid item xs={12} md={6}>
          <InnerContainer>
            <Image
              onClick={() => this.openPreview(photo1)}
              src={`${API_ROOT}/asset/${photo1}`}
            />
          </InnerContainer>
          <FieldImageName>Polar Diagram</FieldImageName>
        </Grid>
        <Grid item xs={12} md={6}>
          <InnerContainer>
            <Image
              onClick={() => this.openPreview(photo2)}
              src={`${API_ROOT}/asset/${photo2}`}
            />
          </InnerContainer>
          <FieldImageName>Luminaire Dimensions</FieldImageName>
        </Grid>

        <PreviewImageModal
          open={this.state.preview}
          onClose={this.closePreview}
          image={this.state.activeAsset}
        />
      </Grid>
    );
  }
}

export default AddPhoto;
